const NAME = "HISTORICAL_PROCESSES_PAGE";

export default NAME;
